import React from "react";
import Textarea from "../../../../shared/ui/shadcn/textarea";
import { InfoBoxWrapper } from "../Styled";

interface NoteProps {
    text: string;
    setText: (val: string) => void;
    isView?: boolean;
    maxLength?: number;
}

const Note = ({ text, setText, isView, maxLength = 500 }: NoteProps) => {
    const length = text?.length || 0;
    const remaining = maxLength - length;

    const Header = () => (
        <div className="tw-flex tw-items-center tw-gap-3">
            <div className="tw-text-xl tw-font-semibold tw-text-gray-900">Ghi chú đơn hàng</div>
        </div>
    );

    return (
        <InfoBoxWrapper>
            <Header />
            <div className="tw-h-px tw-w-full tw-bg-secondary" />

            {!isView && (
                <div className="tw-flex tw-flex-col tw-gap-2">
                    <Textarea
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="Nhập ghi chú đơn hàng tại đây"
                        maxLength={maxLength}
                        aria-label="Ghi chú đơn hàng"
                        className="tw-min-h-[120px]"
                    />
                    <div className="tw-flex tw-items-center tw-justify-between tw-text-sm tw-text-gray-500">
                        <div>Gợi ý: Ghi rõ yêu cầu đặc biệt, thời gian giao hàng, v.v.</div>
                        <div className={remaining < 0 ? "tw-text-red-600" : ""}>{length}/{maxLength}</div>
                    </div>
                </div>
            )}

            {isView && (
                <div className="tw-text-base tw-leading-6 tw-text-gray-800 tw-whitespace-pre-wrap">
                    {text && text.trim().length > 0 ? text :
                        <span className="tw-text-gray-400 tw-italic">Không có ghi chú</span>}
                </div>
            )}
        </InfoBoxWrapper>
    );
};

export default Note;
